import React from 'react';
import ReactDOM from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import LandingPage from './components/base-components/LandingPage';
import { purgeStoredPassword } from './helpers/credentialGuards';
import { ensureDocumentStructure, patchDocumentAccessors, patchRemoveChildNotFound } from './helpers/domGuards';
import { envStrToBoolean } from './helpers/utils';
import './i18n';
import './index.scss';
import './polyfills';
import reportWebVitals from './reportWebVitals';
import store from './store/index';

ensureDocumentStructure();

purgeStoredPassword();

patchRemoveChildNotFound();
const isEnableLandingPage = envStrToBoolean(process.env.REACT_APP_LANDING_PAGE);

patchDocumentAccessors();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <>
    {isEnableLandingPage ? (
      <LandingPage />
    ) : (
      <BrowserRouter>
        <HelmetProvider>
          <Helmet defer={true} />
          <Provider store={store}>
            <App />
          </Provider>
        </HelmetProvider>
      </BrowserRouter>
    )}
  </>
);

reportWebVitals();
